import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { createInfiniteHitsSessionStorageCache } from "react-instantsearch-dom";
import axios from "axios";
import {
  Spin,
  Row,
  Col,
  Button,
  Image,
  Typography,
  Skeleton,
  Tabs,
} from "antd";
import { useGlobal } from "store/index";
import Breadcrumb from "./Breadcrumb";
import API_KEY from "api";
import AlgoliaFilters from "routes/SourceWiz/AlgoliaFilters/App";
import ProductActions from "redux/actions/productActions";
import CustomInfiniteHits from "./CustomInfiniteHits";
import FloatingCard from "./FloatingCard";
import LoadingModal from "./LoadingModal";
import { getData, sendData } from "store/firebase/methods";
import { LoadingOutlined } from "@ant-design/icons";
import { child } from "firebase/database";
import Modal from "antd/lib/modal/Modal";
import Title from "antd/lib/skeleton/Title";
import ImageBox from "components/ImageBox";

const antIcon = <LoadingOutlined style={{ fontSize: 30 }} spin />;
const sessionStorageCache = createInfiniteHitsSessionStorageCache();
const { Text } = Typography;
function SelectProducts({ checkedProducts, actions, allHits }) {
  const [collectionDetails, setCollectionDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const collectionId = params?.id;
  const [globalState, setGlobalState] = useGlobal();
  const [spinning, setSpinning] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [showExclusive, setShowExclusive] = useState(false);
  const { userCategories } = globalState;
  const history = useHistory();
  const location = useLocation();
  const [exclusiveProducts, setExclusiveProducts] = useState(checkedProducts);

  useEffect(() => {
    setSpinning(true);
    API_KEY.URL.get(`${API_KEY.path.collections}/${collectionId}`, {
      params: {
        // "filter[id][_eq]": collectionId,
        deep: { products: { _limit: -1 } },
        fields: "*,products.id,products.products_id",
      },
    })
      .then((res) => {
        console.log("catalogue-",res);
        const data = res.data?.data;
        setCollectionDetails(data);

        getData()
          .then((products) => {
            console.log("products--", products);
            setSpinning(false);
            if (products) {
              actions.setProducts([...products]);
            }
          })
          .catch((err) => {
            console.log(err);
            setSpinning(false);
          });
        // if(data?.products?.length>0){
        //   setCollectionProducts(data.products.map(pro=>pro?.products_id))
        // }
      })
      .catch((err) => {
        setSpinning(false);
      });
  }, [collectionId]);

  // useEffct to get localstorage data
  useEffect(() => {
    const selectedProducts = JSON.parse(
      localStorage.getItem(`selectedProducts`)
    );
    if (selectedProducts) {
      actions.setProducts(selectedProducts, collectionId);
    }
  }, [setGlobalState]);

  useEffect(() => {
    setExclusiveProducts(
      checkedProducts.filter((item) =>
        item?.is_exclusive_product ? item?.is_exclusive_product : false
      )
    );

    if (exclusiveProducts.length === 0) {
      setShowExclusive(false);
    }
  }, [checkedProducts]);

  const handleView = () => {
    getData()
      .then((products) => {
        if (products) {
          setLoading(true);
          // var productsFromStorage = localStorage.getItem("selectedProducts");
          // var products = JSON.parse(productsFromStorage);
          const user = localStorage.getItem("user");
          const token = JSON.parse(user).access_token;

          // collection product ids
          const collectionProductsIds = collectionDetails.products.map(
            (item) => item?.id
          );

          // collection products ids
          const productIdsFromCollection = collectionDetails.products.map(
            (item) => item?.products_id
          );
          var nonExistingProducts = products.filter(
            (item) => !productIdsFromCollection.includes(item?.id)
          );
          const selectedProducts = products.filter((pro) =>
            productIdsFromCollection.includes(pro?.id)
          );
          const selectedProductsIDs = selectedProducts.map(
            (pro) => pro?.collection_product_id
          );

          var requestPayload;
          if (collectionProductsIds.length === 0) {
            products = products.map((item) => {
              item.products_id = item.id;
              
              delete item.id;
              item.attributes = item?.attributes.map((attr) => {
                return {
                  attribute_values_id: {
                    attribute_id: attr?.attribute_values_id?.attribute_id?.id,
                    values: attr?.attribute_values_id?.values,
                    composite: attr?.attribute_values_id?.composite,
                  },
                };
              });

              if (item?.variants?.length > 0) {
                item.variants = item?.variants.map((attr) => {
                  delete attr.id;
                  return {
                    ...attr,
                    attributes: attr?.attributes
                      ? attr?.attributes.map((attr) => {
                          return {
                            attribute_values_id: {
                              attribute_id:
                                attr?.attribute_values_id?.attribute_id?.id,
                              values: attr?.attribute_values_id?.values,
                              composite: attr?.attribute_values_id?.composite,
                            },
                          };
                        })
                      : [],
                  };
                });
              }

              return {
                products_id: item?.products_id,
                sub_category:
                  typeof item?.sub_category === "object"
                    ? item?.sub_category.join(",")
                    : item?.sub_category || "",
                attributes: item?.attributes,
                variants: item?.variants,
              };
            });
            requestPayload = {
              products: products,
            };
          } else {
            let productPayload;
            nonExistingProducts = nonExistingProducts.map((item) => {
              item.products_id = item.id;
              delete item.id;

              item.attributes = item?.attributes.map((attr) => {
                return {
                  attribute_values_id: {
                    attribute_id: attr?.attribute_values_id?.attribute_id?.id,
                    values: attr?.attribute_values_id?.values,
                    composite: attr?.attribute_values_id?.composite,
                  },
                };
              });
              if (item?.variants?.length > 0) {
                item.variants = item?.variants.map((attr) => {
                  delete attr.id;
                  return {
                    ...attr,
                    attributes:
                      attr?.attributes &&
                      attr?.attributes.map((attr) => {
                        return {
                          attribute_values_id: {
                            attribute_id:
                              attr?.attribute_values_id?.attribute_id?.id,
                            values: attr?.attribute_values_id?.values,
                            composite: attr?.attribute_values_id?.composite,
                          },
                        };
                      }),
                  };
                });
              }
              productPayload = {
                products_id: item?.products_id,
                attributes: item?.attributes,
                variants: item?.variants,
                sub_category:
                  typeof item?.sub_category === "object"
                    ? item?.sub_category.join(",")
                    : item?.sub_category || "",
              };
              return productPayload;
            });

            requestPayload = {
              products: [...nonExistingProducts, ...selectedProductsIDs],
            };
          }

          axios
            .post(
              `${process.env.REACT_APP_API_SERVICE}items/collections/?collections_id=${collectionId}&token=${token}`,
              requestPayload
            )
            .then((response) => {
              if (response.status === 200) {
                setTimeout(() => {
                  setLoading(false);
                  location?.state?.type
                    ? history.push(`/catalogue-table/${collectionId}/edit`)
                    : history.push(`/catalogue-table/${collectionId}`);
                }, 2000);
              }
            })
            .catch((error) => {
              setLoading(false);
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSelectAll = (hits) => {
    setIsChecked((state) => !state);
    if (hits.length > 0) {
      hits = hits.map(function (item) {
        // firebase does not allow to add keys with special characters
        delete item?.["transformedAttributes"];
        delete item?.["_highlightResult"];
        return item;
      });
      if (isChecked) {
        if (checkedProducts && hits) {
          let hitsIds = hits.map((pro) => pro?.id);
          let removedProducts = checkedProducts.filter(
            (pro) => !hitsIds.includes(pro?.id)
          );

          actions.removeMultipleProducts(removedProducts);
        } else {
          actions.removeMultipleProducts([]);
        }
      } else {
        if (checkedProducts && hits) {
          let productsIds = checkedProducts.map((pro) => pro?.id);
          console.log("hits", hits);
          let nonExistingProducts = hits.filter(
            (pro) => !productsIds.includes(pro?.id)
          );
          console.log("nonExistingProducts:", nonExistingProducts);
          actions.addMultipleProducts(nonExistingProducts);
        } else {
          actions.addMultipleProducts(hits);
        }
      }
    } else {
    }
  };

  const handleSaveView = () => {
    if (exclusiveProducts.length > 0) {
      setShowExclusive(true);
    } else {
      handleView();
    }
  };

  const handleRemove = (item) => {
    actions.removeProduct(item);
  };

  const handleRemoveAllExclusive = () => {
    let allExclusiveProducts = checkedProducts.filter(
      (item) => !item?.is_exclusive_product
    );
    actions.removeMultipleProducts(allExclusiveProducts);

    setShowExclusive(false);
    handleView();
  };

  const handleExclusiveSave = () => {
    setShowExclusive(false);
    handleView();
  };

  return (
    <>
      <Modal
        visible={showExclusive && exclusiveProducts.length > 0}
        footer={false}
        onCancel={() => setShowExclusive(false)}
        width={600}
        style={{ top: "5em" }}
      >
        <Col>
          <Row
            style={{
              fontSize: "18px",
              fontStyle: "normal",
              fontWeight: "bold",
            }}
          >
            You have selected {exclusiveProducts.length} exclusive products
          </Row>
          <Row>
            Remove the products you don't want to include in this catalogue
          </Row>

          <Row
            style={{
              overflow: "auto",
              maxHeight: "34em",
              marginTop: "2em",
              marginBottom: "2em",
            }}
          >
            {exclusiveProducts.map((item, index) => {
              return (
                <ExclusiveProducts
                  key={index}
                  item={item}
                  index={index}
                  handleRemove={() => handleRemove(item)}
                  // handleProductSelection={onClickCard}
                  // isChecked={checkedProducts.some((it) => it?.id === item?.id)}
                />
              );
            })}
          </Row>

          <Row>
            <Col>
              <Button
                style={{ height: 40, marginRight: "12.4em" }}
                type="primary"
                size="large"
                onClick={handleRemoveAllExclusive}
              >
                Remove all & Continue
              </Button>
            </Col>
            <Col>
              <Button
                style={{
                  height: 40,
                  float: "right",
                  background: "black",
                  color: "white",
                }}
                size="large"
                onClick={handleExclusiveSave}
              >
                Keep & Continue
              </Button>
            </Col>
          </Row>
        </Col>
      </Modal>
      <Breadcrumb />

      <Row style={{ marginTop: "1rem" }}>
        <Col span={24}>
          <div
            style={{
              borderBottom: "1px solid #E6E7E7",
            }}
          >
            <Text
              style={{
                fontSize: "24px",
                fontStyle: "normal",
                fontWeight: "bold",
                fontFamily: "Avenir",
              }}
            >
              {collectionDetails?.collection_name} for{" "}
              {collectionDetails?.buyer_name}
            </Text>
          </div>
        </Col>
      </Row>

      <LoadingModal loading={loading} selectedProdutcs={checkedProducts} />
      <AlgoliaFilters
        Hits={
          <Spin spinning={spinning} indicator={antIcon} size="large">
            <CustomInfiniteHits
              cache={sessionStorageCache}
              //setHitsData={setHitsData}
            />
          </Spin>
        }
        primaryText="Select products for the catalogue"
        handleSelectAll={handleSelectAll}
        isChecked={isChecked}
        setIsChecked={setIsChecked}
        checkedProducts={checkedProducts}
      />
      {/* {comp} */}
      {collectionDetails && checkedProducts && checkedProducts.length > 0 ? (
        <FloatingCard
          history={history}
          collectionId={collectionId}
          selectedProdutcs={checkedProducts}
          collectionDetails={collectionDetails}
          handleView={handleSaveView}
          loading={loading}
        />
      ) : null}
    </>
  );
}

const mapStateToProps = (state) => ({
  checkedProducts: state.checkedProducts.data,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      setProducts: ProductActions.setProducts,
      addProduct: ProductActions.addProduct,
      removeProduct: ProductActions.removeProduct,
      addMultipleProducts: ProductActions.addMultipleProducts,
      removeMultipleProducts: ProductActions.removeMultipleProducts,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectProducts);

function ExclusiveProducts({ item, index, isChecked, handleRemove }) {
  const comp = useMemo(() => {
    return (
      <Col xs={24} sm={24} md={12} lg={24} xl={24}>
        <Row
          style={{
            padding: "0.4em",
            borderBottom: "1px solid #E6E7E7",
            paddingTop: "1em",
            paddingBottom: "1em",
          }}
        >
          <Col style={{ marginRight: "2em" }}>
            <Row style={{ border: "0.2em" }}>
              <Image
                key={item?.secondary_category_id?.id}
                // className="product-card"
                src={
                  item && item.product_images[0]
                    ? `${process.env.REACT_APP_CLOUDINARY}/c_lpad,h_214,q_100,w_283/${item?.product_images[0]?.directus_files_id}`
                    : "http://placehold.jp/24/0a8f8d/ffffff/283x214.png?text=Product Image"
                }
                fallback={
                  item && item.product_images[0]
                    ? `${process.env.REACT_APP_DIRECTUS}assets/${item?.product_images[0]?.directus_files_id}?transforms=[["resize",{"width":283,"height":214,"fit":"contain","background":"white"}]]`
                    : "http://placehold.jp/24/0a8f8d/ffffff/283x214.png?text=Product Image"
                }
                alt={"product name"}
                style={{
                  borderRadius: "4px",
                  //padding: "4px",
                  width: "5.8em",
                  height: "5.8em",
                  objectFit: "contain",
                  border: "1px solid #ddd",
                }}
                preview={false}
              />
            </Row>
          </Col>

          <Col style={{ marginRight: "4em", width: "6em" }}>
            <Row>
              <Text
                style={{
                  color: "#4F5655",
                  fontSize: "14px",
                  fontWeight: "normal",
                }}
              >
                Product ID
              </Text>
            </Row>
            <Row>
              <Text
                style={{
                  color: "#040E0C",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                ID : {item?.product_id ? item?.product_id : "No product id"}
              </Text>
            </Row>
          </Col>

          <Col style={{ marginRight: "4em", width: "9em" }}>
            <Row>
              <Text
                style={{
                  color: "#4F5655",
                  fontSize: "14px",
                  fontWeight: "normal",
                }}
              >
                Exclusive for
              </Text>
            </Row>
            <Row
              style={{
                color: "#040E0C",
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              {item?.exclusive_buyer_details.join(", ")}
            </Row>
          </Col>

          <Col>
            <Row>
              <Button
                type="ghost"
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "1.5em",
                  margin: "0.5em",
                }}
                size="medium"
                onClick={handleRemove}
              >
                Remove
              </Button>
            </Row>
          </Col>
        </Row>
        {/* </Skeleton> */}
      </Col>
    );
  }, [item, index, isChecked]);

  return comp;
}
